export const LEARNER_LAYOUT_BREAKPOINTS = {
  singleDesktopPx: 640,
  doubleDesktopPx: 1100,
} as const;

export const LEARNER_LAYOUT_MEDIA = {
  maxMobile: `(max-width: ${LEARNER_LAYOUT_BREAKPOINTS.singleDesktopPx - 1}px)`,
  singleDesktop: `(min-width: ${LEARNER_LAYOUT_BREAKPOINTS.singleDesktopPx}px)`,
  doubleDesktop: `(min-width: ${LEARNER_LAYOUT_BREAKPOINTS.doubleDesktopPx}px)`,
} as const;
